module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.getStudentSummary.my_comments), function(comment, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-4",
      class: [index !== _vm.getStudentSummary.my_comments.length - 1 ? 'individual-comment' : '', comment.is_hidden ? 'hidden-record' : '' ]
    }, [(comment) ? _c('div', {
      staticClass: "flex justify-between text-xs text-gray-500"
    }, [_c('div', {
      staticClass: "flex justify-between truncate-text items-end py-1 font-manrope"
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.inResponseTo(comment)) + " ")]), _vm._v(" "), (_vm.createdAfterEnd(comment)) ? _c('div', {
      staticClass: "text-xs text-red-500 px-3"
    }, [_vm._v("\n          Posted after close\n        ")]) : _vm._e()]), _vm._v(" "), _c('StarButton', {
      staticClass: "mx-3",
      attrs: {
        "type": "summary",
        "comment": comment
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "white-spaced-text break-words py-1 font-manrope text-gray-900"
    }, [_vm._v("\n      " + _vm._s(comment.content) + "\n    ")]), _vm._v(" "), (_vm.$route.name === 'roundtable.discussion') ? _c('div', [_c('button', {
      staticClass: "text-primary hover:text-primary-dark cursor-pointer font-manrope",
      on: {
        "click": function($event) {
          return _vm.goToCommentContext(comment)
        }
      }
    }, [_vm._v("\n        See Context\n      ")])]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2fa6c052!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/commentSummary/commentSummary.vue
// module id = 1194
// module chunks = 61